export const imgprefix='https://edu.9man.com/Uploads/';
export const audioprefix='https://edu.9man.com/Uploads/';



// WEBPACK FOOTER //
// ./src/common/js/globalvalue.js